import React from "react";
import RealDate from "./RealDate";
import WeatherIcon from "./WeatherIcon";
import WeatherTemperature from "./WeatherTemperature";

export default function WeatherMain(props) {
  return (
    <div>
      <h1>{props.data.city}</h1>
      <ul>
        <li>
          <RealDate date={props.data.date} />
        </li>
        <li className="text-capitalize">{props.data.description}</li>
      </ul>
      <div className="row">
        <div className="col-6">
          <div>
            <WeatherIcon code={props.data.icon} alt={props.data.description} />
          </div>
          <WeatherTemperature celsius={props.data.temperature} />
        </div>
        <div className="col-6">
          <ul className="mt-5">
            <li>Humidity: {props.data.humidity}%</li>
            <li>Wind:{props.data.wind}km/h</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
